import { useLocation } from 'react-router-dom';

export const usePageTitle = () => {
  const location = useLocation();
  const path = location.pathname;

  const titleMap: { [key: string]: string } = {
    '/dashboard': 'Dashboard',
    '/project': 'Project Management',
    '/project/unit': 'Units Management',
    '/project/unit/add': 'Add New Unit',
    '/bookings': 'Bookings Management',
    '/booking/view': 'View Bookings',
    '/booking/details': 'Booking Details',
    '/booking/add': 'Add New Booking',
    '/booking/edit': 'Edit Booking',
    '/booking/cancelled': 'Cancelled Bookings',
    '/booking/clean': 'Bookings Clean',
    '/booking/transferred': 'Transferred Bookings',
    '/booking/history': 'Booking History',
    '/booking/history-new': 'Booking History',
    '/booking/summary': 'Booking Summary',
    '/historical-data-upload': 'Historical Data Upload',
    '/upload-data': 'Upload Data',
    '/partners': 'Partners Management',
    '/partners/add': 'Add Partner',
    '/broker': 'Broker Management',
    '/broker/add': 'Add Broker',
    '/ledger/customer': 'Customer Ledger',
    '/ledger/partner': 'Partner Ledger',
    '/ledger/partner/add': 'Add Partner Transaction',
    '/ledger/income': 'Income Management',
    '/income': 'Income Management',
    '/income/add': 'Add New Income',
    '/income/edit': 'Edit Income',
    '/income/view': 'View Income',
    '/ledger/add-income': 'Add New Income',
    '/ledger/other': 'Other Income',
    '/ledger/other/add': 'Add Other Income',
    '/expenses': 'Expenses Management',
    '/expenses/add': 'Add Expense',
    '/ledger/expenses': 'Expenses Management',
    '/ledger/expenses/add': 'Add Expense',
    '/other-income': 'Other Income',
    '/other-income/add': 'Add Other Income',
    '/hidden-income': 'Receivable Income Management',
    '/add-receivable-income': 'Add Receivable Income',
    '/approval/cheque': 'Cheque Authorization',
    '/approval/booking': 'Booking Authorization',
    '/approval/income': 'Income Authorization',
    '/approval/hidden-income': 'Receivable Income Authorization',
    '/return-cancel-income': 'Return Cancel Income',
    '/cancel-receivable-income': 'Cancel Receivable Income',
    '/cancel-summary': 'Cancel Summary',
    '/auth/user': 'User Management',
    '/auth/system-user': 'System Users',
    '/auth/system-user/add': 'Add System User',
    '/auth/roles': 'Roles Management',
    '/auth/roles/add': 'Add Role',
    '/auth/roles/edit': 'Edit Role',
    '/auth/roles/view': 'View Role',
    '/auth/permissions': 'Permissions Management',
    '/reports': 'Reports'
  };

  return titleMap[path] || 'Dashboard';
};
